// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"WidgetConfiguration_fieldset__1SMjs"};